import { apiRouter } from '$domain/model/apiRouter'
import familiadosApiClient from '$utils/familiadosApiClient'
import { apiErrorService } from '$utils/services/apiErrorService'
import { mapAccompanimentsBookedServiceList } from './accompanimentsBookedServices.mapper'
import { AccompanimentsBookedServiceDto } from './accompanimentsBookedServices.model'

const findBookedServiceList = async (searchTerm: string) => {
  try {
    const bookedServiceListDto = await familiadosApiClient.get<AccompanimentsBookedServiceDto[]>(
      apiRouter.getAccompanimentsBookedServiceListPath(),
      { offset: 0, limit: 50, searchTerm },
    )
    return mapAccompanimentsBookedServiceList(bookedServiceListDto)
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const accompanimentsBookedServicesManager = { findBookedServiceList }



// WEBPACK FOOTER //
// ./src/domain/model/nursingHome/accompaniments/accompanimentsBookedServices/accompanimentsBookedServices.manager.ts